import { bopApi } from '@/lib/api/client';

const STATISTICS_PATH = 'v1/instant-trade/statistics';

export interface MarketVolume {
  /** Decimal string, EUR */
  volume: string;
  trades: number;
  /** Decimal string, EUR */
  fees: string;
}

/**
 * Responds 404 `{ error: 'No statistics data' }` when the statistics cache is
 * missing — callers surface that as an empty/error state.
 */
export interface InstantStatisticsResponse {
  statistics: {
    marketVolumes: Record<string, MarketVolume>;
    /** Present on the wire but unused by the UI */
    hourlyVolumes: Record<string, unknown>;
  };
  /** ISO-8601 */
  lastUpdated: string;
}

export interface InstantStatistics {
  totalVolume: number;
  totalTrades: number;
  totalFees: number;
  marketVolumes: Record<string, MarketVolume>;
  lastUpdated: string;
}

export const mapInstantStatistics = (raw: InstantStatisticsResponse): InstantStatistics => {
  const markets = Object.values(raw.statistics.marketVolumes);
  return {
    totalVolume: markets.reduce((sum, market) => sum + Number.parseFloat(market.volume), 0),
    // trades is already a number on the wire
    totalTrades: markets.reduce((sum, market) => sum + market.trades, 0),
    totalFees: markets.reduce((sum, market) => sum + Number.parseFloat(market.fees), 0),
    marketVolumes: raw.statistics.marketVolumes,
    lastUpdated: raw.lastUpdated,
  };
};

export const getInstantStatistics = () => bopApi.get(STATISTICS_PATH).json<InstantStatisticsResponse>();
